import '@nodeModules/flatpickr/dist/flatpickr.min.css';
import '@nodeModules/flatpickr/dist/themes/airbnb.css';
import '@/style/app.scss';
import '@/style/pages/collections/collections.scss';
import { initSentry } from '@/js/services/sentry.js';
import { initGDPRConsent } from '@/js/partials/gdpr-consent.js';
import { initHeader } from '@/js/partials/header.js';
import { initNewsletterForms } from '@/js/partials/newsletter.js';
import { initTracking } from '@/js/services/tracking.js';
import { initModals } from '@/js/partials/modals.js';
import { initPageJs } from '@/js/pages/collections.js';

window.addEventListener('DOMContentLoaded', () => {
	initSentry();
	initGDPRConsent();
	initHeader();
	initNewsletterForms();
	initTracking();
	initModals();
	initPageJs();
});
